// @flow

import React, {createContext, useContext, useMemo} from 'react';

import {DataTableDragEventsContext, DRAG_EVENTS_DEFAULT_CONTEXT} from './data-table-drag-events-context';
import {ScrollContext, SCROLL_DEFAULT_CONTEXT} from './data-table-scroll-context';

import type {Node} from 'react';
import type {DataTableDragEventsContextType} from './data-table-drag-events-context';
import type {ScrollContextType} from './data-table-scroll-context';


type Props = {|
    children: Node,
|};

export type DataTableCombinedContextType = {|
    dataTableDragEventsContext: DataTableDragEventsContextType,
    scrollContext: ScrollContextType,
|};

const DEFAULT_CONTEXT: DataTableCombinedContextType = {
    dataTableDragEventsContext: DRAG_EVENTS_DEFAULT_CONTEXT,
    scrollContext: SCROLL_DEFAULT_CONTEXT
};

export const DataTableCombinedContext: React$Context<DataTableCombinedContextType>
    = createContext<DataTableCombinedContextType>(DEFAULT_CONTEXT);
DataTableCombinedContext.displayName = 'DataTableCombinedContext';

export function DataTableCombinedContextProvider({children}: Props): Node {
    const dataTableDragEventsContext = useContext<DataTableDragEventsContextType>(DataTableDragEventsContext);
    const scrollContext = useContext<ScrollContextType>(ScrollContext);
    const value = useMemo(()=> ({
        dataTableDragEventsContext,
        scrollContext
    }), [dataTableDragEventsContext, scrollContext]);

    return (
        <DataTableCombinedContext.Provider value={value}>
            {children}
        </DataTableCombinedContext.Provider>
    );
}

            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("./data-table-drag-events-context");

require("./data-table-scroll-context");
